export default __webpack_public_path__ + "static/media/brainHealthStudio3.f98b13df.png";